module.exports = __webpack_public_path__ + "assets/img/entry.8e0b2a24.png";